import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PageHeaderProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbItem[];
  actions?: ReactNode;
}

export function PageHeader({ icon, title, subtitle, breadcrumbs, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        {/* Icon - monochrome, same height as title */}
        {icon && (
          <div className="flex-shrink-0 text-gray-400">
            {icon}
          </div>
        )}

        {/* Title + Breadcrumbs */}
        <div className="min-w-0">
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {/* Breadcrumbs inline */}
            {breadcrumbs && breadcrumbs.length > 0 && (
              <nav className="flex items-center gap-1.5 text-sm text-gray-400">
                <span className="text-gray-300">|</span>
                {breadcrumbs.map((item, index) => (
                  <span key={index} className="flex items-center gap-1.5">
                    {index > 0 && <span className="text-gray-300">/</span>}
                    {item.href ? (
                      <Link to={item.href} className="hover:text-gray-600">
                        {item.label}
                      </Link>
                    ) : (
                      <span>{item.label}</span>
                    )}
                  </span>
                ))}
              </nav>
            )}
          </div>
          {subtitle && (
            <p className="text-gray-500 text-sm mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>

      {/* Actions */}
      {actions && (
        <div className="flex-shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
